const General = {
    routes: {
        home: '/',
        login: '/entrada',
        logout: '/salida',
        animals: '/animales',
        lands: '/fincas',
        analysis: '/analisis',
        password: '/contrasena',
        profile: '/perfil',
        register: '/registro',
        test: '/test',
        users: '/usuarios'
    },
    global: {
        appName: 'Mi Finca',
        alias: 'Alias',
        welcome: 'Bienvenido a la comunidad ',
        loading: 'Cargando datos...',
        download: 'Descargar',
        delete: 'Eliminar',
        menu: 'Menu',
        exit: 'Salir',
        seeDetails: 'Ver detalles',
        filter: 'Filtrar',
        sort: 'Ordenar',
        total: 'Total',
        true: 'Si',
        false: 'No'
    },
    date: {
        title: 'Fecha',
        since: 'Desde',
        to: 'Hasta',
        year: 'Año',
        years: 'Años',
        month: 'Mes',
        months: 'Meses',
        week: 'Semana',
        weeks: 'Semanas',
        day: 'Día',
        days: 'Días',
        daysSinceLast: 'Días desde el último parto'
    },
    form: {
        create: 'Crear',
        add: 'Añadir',
        close: 'Cerrar',
        delete: 'Eliminar',
        description: 'Descripción',
        edit: 'Editar',
        enter: 'Entrar',
        email: 'Correo electrónico',
        hide: 'Ocultar',
        name: 'Nombre',
        open: 'Abrir',
        password: 'Contraseña',
        save: 'Guardar',
        saveandclose: 'Guardar y cerrar',
        apply: 'Aplicar',
        select: 'Elija una opcion',
        send: 'Enviar',
        show: 'Mostrar',
        signOut: 'Cerrar sesión',
        submit: 'Enviar',
        surname: 'Apellidos',
        title: 'Título',
        today: 'Hoy',
        photo: 'Foto',
        addPhoto: 'Añadir foto',
        changePhoto: 'Cambiar foto',
        photos: 'Fotos',
        addPhotos: 'Añadir fotos',
        favPhoto: 'Fotos principal',
        typeToSearch: 'Escriba para buscar',
        maxFileSize: 'El tamaño máximo para cada archivo es de 10Mb',
        helpers: {
            typeToSearch:
                'El filtro compara a partir de 3 caracteres sin importar la posición o las mayúsculas. El filtro no hace comparaciones por similitud.'
        }
    },
    error: {
        auth_wrong_password: 'Usuario o contraseña incorrectos',
        auth_user_not_found: 'Usuario o contraseña incorrectos',
        auth_email_already_in_use: 'Este correo ya está en uso',
        auth_weak_password: 'La contraseña debe tener al menos 6 caracteres',
        auth_invalid_email: 'Email inválido',
        passwordMatch: 'Las contraseñas no coinciden',
        required: 'Este campo es obligatorio',
        default: 'Ups! Algo ha salido mal'
    }
};

export default General;
